import { render, staticRenderFns } from "./CreateUnitDialog.vue?vue&type=template&id=7bb695da&scoped=true&"
import script from "./CreateUnitDialog.vue?vue&type=script&lang=js&"
export * from "./CreateUnitDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateUnitDialog.vue?vue&type=style&index=0&id=7bb695da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb695da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
